import { Backgrounds } from '@trello/boards';
import {
  biggestPreview,
  smallestPreviewBiggerThan,
  waitForImageLoad,
} from '@trello/image-previews';
// eslint-disable-next-line no-restricted-imports
import $ from '@trello/jquery';
import { UnsplashTracker } from '@trello/unsplash';

import { FavIcon } from 'app/scripts/lib/favicon';
import {
  BOARD_VIEW_BACKGROUND_CLASSES,
  CUSTOM_BOARD_BACKGROUND_CLASS,
  CUSTOM_BOARD_BACKGROUND_TILED_CLASS,
  DARK_BOARD_BACKGROUND_CLASS,
  GRADIENT_BOARD_BACKGROUND_CLASS,
  LIGHT_BOARD_BACKGROUND_CLASS,
  STATIC_COLOR_BACKGROUND_CLASS,
} from './boardViewBackgroundClasses';

const clearBoardBackground = function () {
  $('#trello-root').removeClass(BOARD_VIEW_BACKGROUND_CLASSES).css({
    'background-image': '',
    'background-color': '',
  });
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const getBoardBackgroundUrl = (prefs: any) => {
  let url = prefs.backgroundImage;
  if (Object.prototype.hasOwnProperty.call(Backgrounds, prefs.background)) {
    // Special handling for our default backgrounds, to avoid using the
    // really huge versions
    url =
      smallestPreviewBiggerThan(prefs.backgroundImageScaled, 640, 480)?.url ||
      url;
  } else {
    url =
      biggestPreview(prefs.backgroundImageScaled, prefs.backgroundImage)?.url ||
      url;
  }

  let smallUrl = url;
  if (!prefs.backgroundTile) {
    smallUrl =
      smallestPreviewBiggerThan(prefs.backgroundImageScaled, 64, 64)?.url ||
      prefs.backgroundImage;
  }

  return { url, smallUrl };
};

export const renderBoardBackground = function (
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  this: any,
  waitForImage = false,
) {
  clearBoardBackground();

  const prefs = this.model.get('prefs');
  const {
    background,
    backgroundBrightness,
    backgroundImage,
    backgroundColor,
    backgroundTile,
    backgroundTopColor,
    backgroundBottomColor,
  } = prefs;

  // eslint-disable-next-line @trello/enforce-variable-case
  const $body = $('#trello-root');

  if (backgroundBrightness === 'light') {
    $body.addClass(LIGHT_BOARD_BACKGROUND_CLASS);
  } else if (backgroundBrightness === 'dark') {
    $body.addClass(DARK_BOARD_BACKGROUND_CLASS);
  }

  if (background.startsWith('gradient-')) {
    const gradientUrl = backgroundImage;

    $body.addClass(GRADIENT_BOARD_BACKGROUND_CLASS);

    $body.css({
      'background-color': backgroundColor,
      'background-image': `url("${gradientUrl}")`,
    });

    FavIcon.setBackground({
      color: backgroundColor,
      topColor: backgroundTopColor,
      bottomColor: backgroundBottomColor,
    });

    return;
  }

  if (backgroundColor) {
    $body.addClass(STATIC_COLOR_BACKGROUND_CLASS);

    $body.css({
      'background-color': backgroundColor,
    });

    FavIcon.setBackground({ color: backgroundColor });

    return;
  }

  const { url, smallUrl } = getBoardBackgroundUrl(prefs);

  const changeBackgroundImage = () => {
    $body.addClass(CUSTOM_BOARD_BACKGROUND_CLASS);

    if (backgroundTile) {
      $body.addClass(CUSTOM_BOARD_BACKGROUND_TILED_CLASS);
    }

    $body.css({
      'background-image': `url("${url}")`,
    });

    UnsplashTracker.trackOncePerInterval(url);

    FavIcon.setBackground({
      url: smallUrl,
      tiled: backgroundTile,
    });
  };

  if (waitForImage) {
    waitForImageLoad(url).then(changeBackgroundImage);
  } else {
    changeBackgroundImage();
  }
};
